import { render, staticRenderFns } from "./BlockReleasesList.vue?vue&type=template&id=3c6f50e6&"
import script from "./BlockReleasesList.vue?vue&type=script&lang=js&"
export * from "./BlockReleasesList.vue?vue&type=script&lang=js&"
import style0 from "./BlockReleasesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports